import React from 'react';
import '../../styles/Perfil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faEyeSlash, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const Privacidade = () => {
    return (
        <div className='container-direito-interno'>
            <div className='perfil-section-header'>
                <span>Dados</span>
                <h1>Privacidade</h1>
            </div>

            <div className='perfil-card container-opcoes'>
                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faShieldAlt} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Perfil</span>
                        <strong>Dados visíveis apenas na sua conta</strong>
                    </div>
                </div>

                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faDatabase} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Armazenamento</span>
                        <strong>Preferências salvas com segurança</strong>
                    </div>
                </div>

                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faEyeSlash} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Visibilidade</span>
                        <strong>Sem exposição pública do perfil</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacidade;
